/**
 * Sticky Add-to-Cart — AditeqShop
 *
 * Shows the #StickyAtc bar whenever the main product form's submit button
 * is out of the viewport. The bar's button submits the original product
 * form via its `form` attribute, so variant/quantity choices carry over.
 */

(function () {
  var bar = document.getElementById('StickyAtc');
  if (!bar || !('IntersectionObserver' in window)) return;

  var mainSubmit = document.querySelector('.product-form__submit');
  var mainForm = document.getElementById(bar.dataset.formId);
  if (!mainSubmit || !mainForm) return;

  var priceTarget = bar.querySelector('[data-sticky-atc-price]');
  var stickyButton = bar.querySelector('.sticky-atc__button');

  function syncFromMainForm() {
    // Price: mirror whichever price item the theme is currently showing
    var priceSource = document.querySelector(
      '#price-' + bar.dataset.sectionId + ' .price__sale .price-item--sale, ' +
      '#price-' + bar.dataset.sectionId + ' .price__regular .price-item--regular'
    );
    if (priceSource && priceTarget) {
      priceTarget.textContent = priceSource.textContent.trim();
    }
    // Availability: mirror the main button's disabled state (sold out variant)
    if (stickyButton) {
      stickyButton.disabled = mainSubmit.disabled;
      stickyButton.style.opacity = mainSubmit.disabled ? '0.5' : '';
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('sticky-atc--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sticky-atc-visible', visible);
      if (visible) syncFromMainForm();
    },
    { threshold: 0 }
  );
  observer.observe(mainSubmit);

  // Keep price/availability in sync when the variant changes
  mainForm.addEventListener('change', function () {
    // The theme re-renders price async; wait a tick
    setTimeout(syncFromMainForm, 300);
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
      setTimeout(syncFromMainForm, 300);
    }
  });
})();
